import React, { useEffect } from 'react';

import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import Client from './Client';
import RelatedContacts from './RelatedContacts';
import TeamMemberLeads from './TeamMemberLeads';

export default function Contacts(props) {
  const { caseDetails, isLeadSpecific, getDetails } = props;

  return (
    <div className="d-flex case-contact flex-wrap flex-column mb-4">
      <GlobalLoader />
      <div className="row">
        <div className="col-sm-12">{isLeadSpecific && <TeamMemberLeads {...{ caseDetails, getDetails, isLeadSpecific }} />}</div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <RelatedContacts {...{ caseDetails, getDetails, isLeadSpecific }} />
        </div>
      </div>
    </div>
  );
}
